import { FunctionField } from 'react-admin';
import { ChipList } from './ChipList';

interface ReferenceChipFieldProps {
  label?: string;
  idField?: string;
  labelField: string;
  linkTo?: (id: number | string) => string;
  emptyText?: string;
  color?: 'default' | 'primary' | 'secondary' | 'error' | 'info' | 'success' | 'warning';
}

export const ReferenceChipField = ({
  label,
  idField = 'id',
  labelField,
  linkTo,
  emptyText = 'N/A',
  color,
}: ReferenceChipFieldProps) => (
  <FunctionField
    label={label}
    render={(record: Record<string, unknown>) => {
      if (!record) {
        return <ChipList items={[]} emptyText={emptyText} />;
      }

      const id = record[idField] as number | string;
      const labelValue = record[labelField];

      return (
        <ChipList
          items={[
            {
              id,
              label: labelValue?.toString() || emptyText,
              to: linkTo ? linkTo(id) : undefined,
              color,
            },
          ]}
        />
      );
    }}
  />
);
